import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { DiscountService } from 'src/app/services/system-config/discount/discount.service';
import { VendorService } from 'src/app/services/vendor.service';
@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DiscountDetailsComponent implements OnInit, AfterViewInit {
  @Input() data: any;
  discountDetailsForm: FormGroup;
  isFormSubmitted: boolean;
  vendorList: any;
  serviceList: any;
  calculationByList: any[] = [];
  Id: number;
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private vendorService: VendorService,
    public activeModal: NgbActiveModal,
    private discountService: DiscountService,
    private appCoreService: AppCoreService,
    private utilities: Utilities,
  ) { }

  ngOnInit(): void {
    this.calculationByList = ['PERCENTAGE', 'ADDITION', 'MULTIPLICATION'];

    this.discountDetailsForm = this.formBuilder.group({
      ddlVendor: [null, Validators.required],
      ddlService: [null, Validators.required],
      ddlCalculationBy: [null, Validators.required],
      txtAmount: [null, Validators.required],
    });
    this.bindVendors();

    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
  }

  ngAfterViewInit(): void {
    this.bindFields(this.data);
    this.useEnterKey ? this.utilities.focusFirstElement(this.discountDetailsForm) : null;
  }

  async bindFields(cell: any) {
    this.Id = cell.id;
    if (cell) {
      this.discountDetailsForm.get('ddlVendor')?.setValue(cell.vendorid);
      await this.bindVendorService();
      this.discountDetailsForm.controls.ddlService.setValue(cell.serviceid);
      this.discountDetailsForm.controls.ddlCalculationBy.setValue(cell.calculationby);
      this.discountDetailsForm.controls.txtAmount.setValue(cell.amount);

    }
  }

  async bindVendors() {
    try {
      this.vendorService.GetAll().subscribe(res => {
        if (res && res.success) {
          this.vendorList = res.data;
        }
      });

    } catch (err) {
      console.error(err);
    }
  }

  async bindVendorService() {
    const id = this.discountDetailsForm.get('ddlVendor')?.value;
    if (id != null) {
      try {
        const res = await lastValueFrom(this.vendorService.GetAllListByVendor({ id }));
        if (res && res.success) {
          this.serviceList = res.data;
        }

      } catch (error) {
      }
    }
  }

  updateDiscountDetails() {
    this.isFormSubmitted = true;
    if (this.discountDetailsForm.valid) {
      const reqObj = {
        id: this.Id,
        vendorid: this.discountDetailsForm.get('ddlVendor')?.value,
        serviceid: this.discountDetailsForm.get('ddlService')?.value,
        calculationby: this.discountDetailsForm.get('ddlCalculationBy')?.value,
        amount: this.discountDetailsForm.get('txtAmount')?.value
      }

      // console.log(" reqObj : ", reqObj)
      this.discountService.UpdateDiscountInfoById(reqObj).subscribe(res => {
        if (res && res.success) {
          this.activeModal.close('Update Discount Details');
        }
      });
    }
  }

}